import React, { useEffect, useState } from "react";


import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import {
  doctorList,
  getChamberByDoctorIdApi,
  getRegionalManagerApi,
  getRMWorkList,
  RMworkAssignApi,
} from "../../Services/Operations/ProductAPI";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setWorkGroupsRedux } from "../../Redux/user_information";

const WorkAssignEmployee = () => {
  const token = useSelector((state) => state.user.token);

  const [regionalManagers, setRegionalManagers] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [chambersByAssignment, setChambersByAssignment] = useState({});
  const dispatch = useDispatch();

  const [workList, setWorkList] = useState([]);
  const [assignMode, setAssignMode] = useState(false);
  const [manualNameInd, setManualNameInd] = useState(0);
  const [manualName, setManual] = useState("");

  const [workGroups, setWorkGroups] = useState([
    {
      assignedDate: "",
      employeermId: null,
      assignments: [
        {
          doctorId: null,
          shopId: null,
          assignedTime: "",
          visitAddress: "",
          doctorName: "",
        },
      ],
    },
  ]);

  const handleGetWorkAssignedList = async () => {
    try {
      const response = await getRMWorkList(token);
      console.log("getRMWorkList", response);

      if (response.status === 200) {
        setWorkList(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchRegionalManagers = async () => {
      try {
        const response = await getRegionalManagerApi(token);
        console.log("response getRegionalManagerApi : ", response);

        const response1 = await doctorList(token);

        setDoctors(response1);
        setRegionalManagers(response);
      } catch (error) {
        toast.error("Failed to load regional managers");
      }
    };

    fetchRegionalManagers();
    handleGetWorkAssignedList();
  }, [token]);

  const fetchDoctorsByRM = async (rmId) => {
    try {
      const response = await doctorList(rmId, token);
    } catch (error) {
      toast.error("Failed to load doctors");
    }
  };

  const handleGroupChange = (groupIndex, e) => {
    const { name, value } = e.target;
    const updatedGroups = [...workGroups];

    updatedGroups[groupIndex][name] = value;

    if (name === "employeermId") {
      fetchDoctorsByRM(Number(value));
      updatedGroups[groupIndex][name] = Number(value);
    } else {
      updatedGroups[groupIndex][name] = value;
    }

    setWorkGroups(updatedGroups);
  };

  const handleAssignmentChange = async (
    groupIndex,
    assignmentIndex,
    e
  ) => {
    const { name, value } = e.target;
    const updatedGroups = [...workGroups];
    const assignment =
      updatedGroups[groupIndex].assignments[assignmentIndex];

    assignment[name] = value;

    if (name === "doctorId") {
      assignment[name] = Number(value);

      if (value) {
        try {
          const chambers = await getChamberByDoctorIdApi(value, token);

          setChambersByAssignment((prev) => ({
            ...prev,
            [groupIndex]: {
              ...prev[groupIndex],
              [assignmentIndex]: chambers,
            },
          }));

          assignment.shopId = null;
        } catch (error) {
          toast.error("Failed to load chambers");
        }
      }
    } else {
      assignment[name] = value;
    }

    setWorkGroups(updatedGroups);
  };

  const handleChamberSelect = (
    groupIndex,
    assignmentIndex,
    selectedShopId
  ) => {
    const updatedGroups = [...workGroups];

    updatedGroups[groupIndex].assignments[assignmentIndex].shopId =
      Number(selectedShopId);

    setWorkGroups(updatedGroups);
  };

  const handleAddressSelect = (
    groupIndex,
    assignmentIndex,
    addressText
  ) => {
    const updatedGroups = [...workGroups];

    updatedGroups[groupIndex].assignments[
      assignmentIndex
    ].visitAddress = addressText;

    setWorkGroups(updatedGroups);
  };

  const addAssignment = (groupIndex) => {
    const updatedGroups = [...workGroups];

    updatedGroups[groupIndex].assignments.push({
      doctorId: "",
      shopId: "",
      assignedTime: "",
      visitAddress: "",
      doctorName: "",
    });

    setWorkGroups(updatedGroups);
  };

  const removeAssignment = (groupIndex, assignmentIndex) => {
    const updatedGroups = [...workGroups];

    if (updatedGroups[groupIndex].assignments.length <= 1) {
      toast.info("At least one assignment is required");
      return;
    }

    updatedGroups[groupIndex].assignments.splice(assignmentIndex, 1);
    setWorkGroups(updatedGroups);
  };

  const addWorkGroup = () => {
    dispatch(setWorkGroupsRedux(workGroups));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const group of workGroups) {
      console.log(group);

      if (!group.assignedDate || !group.employeermId) {
        toast.error(
          "Please select date and regional manager in each group"
        );
        return;
      }
    }

    try {
      console.log("workGroups : ", workGroups);

      const response = await RMworkAssignApi(workGroups, token);

      if (response.status === 200) {
        toast.success("Work assigned successfully");

        setWorkGroups([
          {
            assignedDate: "",
            employeermId: "",
            assignments: [
              {
                doctorId: "",
                shopId: [],
                assignedTime: "",
              },
            ],
          },
        ]);

        setChambersByAssignment({});
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Error assigning work"
      );
      console.log(error);
    }
  };

  return (
    <div id="main_content" className="wa-page">
      <Header />

      <div className="page">
        <Section />

        <div className="work-assign-container wa-container">
          {/* Page heading */}
          <div className="wa-heading">
            <div>
              <div className="wa-eyebrow">WORK MANAGEMENT</div>
              <h2>Work Assignment to Markeking Executive (Senior)</h2>
              <p>
                Organize doctor visits and manage marketing team schedules.
              </p>
            </div>

            <button
              type="button"
              className={`wa-create-btn ${assignMode ? "wa-create-active" : ""}`}
              onClick={() => setAssignMode(!assignMode)}
            >
              <span>{assignMode ? "−" : "+"}</span>
              {assignMode ? "Close Assignment" : "Assign New Work"}
            </button>
          </div>

          {/* Assignment form */}
          {assignMode && (
            <form onSubmit={handleSubmit} className="work-form wa-form">
              {workGroups.map((group, groupIndex) => (
                <div key={groupIndex} className="work-group wa-work-group">
                  <div className="wa-group-heading">
                    <div className="wa-group-number">
                      {String(groupIndex + 1).padStart(2, "0")}
                    </div>

                    <div>
                      <h3>Assignment Schedule</h3>
                      <p>
                        Select a date, senior marketing executive and doctor
                        visit details.
                      </p>
                    </div>
                  </div>

                  <div className="wa-group-top">
                    <div className="wa-calendar-panel">
                      <div className="wa-field-heading">
                        <span className="wa-field-icon">▦</span>
                        <div>
                          <label>Assigned Date</label>
                          <small>Choose the scheduled work date</small>
                        </div>
                      </div>

                      <DatePicker
                        selected={
                          group.assignedDate
                            ? new Date(group.assignedDate)
                            : null
                        }
                        onChange={(date) => {
                          const updatedGroups = [...workGroups];
                          updatedGroups[groupIndex].assignedDate = date
                            .toISOString()
                            .split("T")[0];

                          setWorkGroups(updatedGroups);
                        }}
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Click to select a date"
                        className="calendar-picker"
                        inline={true}
                      />
                    </div>

                    <div className="wa-manager-panel">
                      <div className="wa-field-heading">
                        <span className="wa-field-icon">♙</span>
                        <div>
                          <label>Senior Marketing Executive</label>
                          <small>Select the responsible executive</small>
                        </div>
                      </div>

                      <select
                        name="employeermId"
                        value={group.employeermId || ""}
                        onChange={(e) =>
                          handleGroupChange(groupIndex, e)
                        }
                        required
                      >
                        <option value="">
                          Select Senior Marketing Executive
                        </option>

                        {regionalManagers.map((rm) => (
                          <option
                            key={rm.employeeId}
                            value={rm.employeeId}
                          >
                            {rm.firstName} {rm.lastName}
                          </option>
                        ))}
                      </select>

                      <div className="wa-manager-note">
                        <span>ⓘ</span>
                        The selected executive will be responsible for
                        this schedule.
                      </div>
                    </div>
                  </div>

                  {/* Doctor assignments */}
                  <div className="wa-assignments-heading">
                    <div>
                      <h4>Doctor Visit Details</h4>
                      <p>
                        Add one or more doctor visits to this schedule.
                      </p>
                    </div>

                    <span className="wa-count">
                      {group.assignments.length}{" "}
                      {group.assignments.length === 1
                        ? "Visit"
                        : "Visits"}
                    </span>
                  </div>

                  {group.assignments.map(
                    (assignment, assignmentIndex) => (
                      <div
                        key={assignmentIndex}
                        className="assignment-group wa-assignment-card"
                      >
                        <div className="wa-assignment-card-header">
                          <div className="wa-visit-label">
                            <span className="wa-visit-icon">✦</span>
                            <div>
                              <strong>
                                Doctor Visit {assignmentIndex + 1}
                              </strong>
                              <small>Visit and chamber information</small>
                            </div>
                          </div>

                          {group.assignments.length > 1 && (
                            <button
                              type="button"
                              className="remove-btn wa-remove-btn"
                              onClick={() =>
                                removeAssignment(
                                  groupIndex,
                                  assignmentIndex
                                )
                              }
                              title="Remove assignment"
                            >
                              −
                            </button>
                          )}
                        </div>

                        <div className="wa-fields-grid">
                          <div className="form-group wa-field">
                            <label>Doctor</label>

                            <select
                              name="doctorId"
                              value={assignment.doctorId || ""}
                              onChange={(e) =>
                                handleAssignmentChange(
                                  groupIndex,
                                  assignmentIndex,
                                  e
                                )
                              }
                              required
                            >
                              <option value="">Select Doctor</option>

                              {doctors.map((doctor) => (
                                <option
                                  key={doctor.id}
                                  value={doctor.id}
                                >
                                  {doctor.firstName} {doctor.lastName}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-group wa-field wa-new-doctor-field">
                            <label>Doctor not listed?</label>

                            <button
                              type="button"
                              className="wa-new-doctor-btn"
                            >
                              + New Doctor
                            </button>
                          </div>

                          {assignment.doctorId &&
                          chambersByAssignment[groupIndex]?.[
                            assignmentIndex
                          ]?.length > 0 ? (
                            <div className="form-group wa-field wa-full-field">
                              <label>Available Chambers</label>

                              <select
                                value={assignment.shopId || ""}
                                onChange={(e) =>
                                  handleChamberSelect(
                                    groupIndex,
                                    assignmentIndex,
                                    e.target.value
                                  )
                                }
                              >
                                <option value="">
                                  Select Chamber
                                </option>

                                {chambersByAssignment[groupIndex]?.[
                                  assignmentIndex
                                ]?.map((chamber) => (
                                  <option
                                    key={chamber.id}
                                    value={chamber.id}
                                  >
                                    {chamber.shopName}
                                  </option>
                                ))}
                              </select>
                            </div>
                          ) : (
                            <div className="form-group wa-field wa-full-field">
                              <label>Visit Address</label>

                              <input
                                placeholder="Enter doctor's visit address"
                                value={assignment.visitAddress || ""}
                                onChange={(e) =>
                                  handleAddressSelect(
                                    groupIndex,
                                    assignmentIndex,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          )}

                          <div className="form-group wa-field">
                            <label>Visit Time</label>

                            <input
                              type="time"
                              name="assignedTime"
                              value={assignment.assignedTime}
                              onChange={(e) =>
                                handleAssignmentChange(
                                  groupIndex,
                                  assignmentIndex,
                                  e
                                )
                              }
                              required
                            />
                          </div>
                        </div>
                      </div>
                    )
                  )}

                  <button
                    type="button"
                    className="add-btn wa-add-assignment"
                    onClick={() => addAssignment(groupIndex)}
                  >
                    <span>+</span> Add Another Doctor Visit
                  </button>
                </div>
              ))}

              {/* Form actions */}
              <div className="form-actions wa-form-actions">
                <button
                  type="button"
                  className="submit-btn wa-add-group-btn"
                  onClick={addWorkGroup}
                >
                  <span>＋</span> Add More
                </button>

                <button
                  type="submit"
                  className="submit-btn wa-submit-btn"
                >
                  Submit Assignment <span>→</span>
                </button>
              </div>
            </form>
          )}

          {/* Assigned work list */}
          <div className="wa-list-section">
            <div className="wa-list-heading">
              <div>
                <div className="wa-eyebrow">RECORDS & TRACKING</div>
                <h3>List of Assigned Works</h3>
                <p>Review previously assigned doctor visits.</p>
              </div>

              <div className="wa-total-count">
                <span>{workList.length}</span>
                <small>Total Records</small>
              </div>
            </div>

            <div className="wa-table-wrapper">
              <table className="wa-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Marketing Person Name</th>
                    <th>Doctor Name</th>
                    <th>Shop Name</th>
                    <th>Assigned Status</th>
                    <th>Assigned Date</th>
                  </tr>
                </thead>

                <tbody>
                  {[...workList].reverse().map((item, ind) => (
                    <tr key={item.id || ind}>
                      <td>
                        <span className="wa-id">#{ind + 1}</span>
                      </td>

                      <td>
                        <div className="wa-person-cell">
                          <span className="wa-person-avatar">
                            {item.marketingPersonName?.charAt(0) || "M"}
                          </span>
                          <span>{item.marketingPersonName}</span>
                        </div>
                      </td>

                      <td>{item.doctorName}</td>
                      <td>{item.shopName}</td>

                      <td>
                        <span
                          className={`wa-status ${
                            String(item.assignedStatus || "")
                              .toLowerCase()
                              .includes("complete")
                              ? "wa-status-completed"
                              : "wa-status-pending"
                          }`}
                        >
                          <span className="wa-status-dot"></span>
                          {item.assignedStatus}
                        </span>
                      </td>

                      <td>
                        <span className="wa-date-cell">
                          {item.assignedDate?.[2]}/
                          {item.assignedDate?.[1]}/
                          {item.assignedDate?.[0]}
                        </span>
                      </td>
                    </tr>
                  ))}

                  {workList.length === 0 && (
                    <tr>
                      <td colSpan="6">
                        <div className="wa-empty-state">
                          <span>▤</span>
                          <strong>No assigned works found</strong>
                          <p>
                            Assigned work records will appear here.
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkAssignEmployee;